import { AutoComplete, Button, Input } from "antd";
import { ROUTES } from "../../../constant/routeConstant";
import style from "./SystemParameter.module.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SystemParameterAdd = () => {
  let { t } = useTranslation();
  return (
    <>
      <div className={style.wrapper}>
        {/* <ButtonDelete2 /> */}
        <div className={style.header}>
          <div className={style.title}>
            <p children={`${t("PARAMETER:PARAMETER")}`} />
          </div>
        
        </div>

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          
        </div>
      </div>
    </>
  );
};
export default SystemParameterAdd;
